export default "__VITE_ASSET__C3Vip2r6__"